export const monthTypes = [
  {
    label: 'Chet',
    value: 'Chet'
  },
  {
    label: 'Vaisakh',
    value: 'Vaisakh'
  },
  {
    label: 'Jeth',
    value: 'Jeth'
  },
  {
    label: 'Harh',
    value: 'Harh'
  },
  {
    label: 'Sawan',
    value: 'Sawan'
  },
  {
    label: 'Bhadon',
    value: 'Bhadon'
  },
  {
    label: 'Assu',
    value: 'Assu'
  },
  {
    label: 'Kattak',
    value: 'Kattak'
  },
  {
    label: 'Maghar',
    value: 'Maghar'
  },
  {
    label: 'Poh',
    value: 'Poh'
  },
  {
    label: 'Magh',
    value: 'Magh'
  },
  {
    label: 'Phaggan',
    value: 'Phaggan'
  }
]
